<!-- Zweck: Stellt die HTML-Struktur für app footer component im Frontend bereit. -->
<div class="footer" style="white-space: nowrap">
  @if (((isMobile|async) && !(mobileShowLinks|async)) || !(isMobile|async)) {
    <div class="footerCol1" [class.mobile]="isMobile|async">
      @if ((currentLieferkunde|async)) {
        <a style="font-size: 11px; line-height: 11px" [class.disabled]="disabled|async" class="tut_lieferkunde_button" routerLink="/lieferkunden" matTooltip="Lieferanschrift  wechseln">
          @if (domainConfig.show_customer_numbers) {
            <span>
              <svg-icon verticalAlign="top">lieferadresse</svg-icon>
              @if (!(isMobile|async)) {
                <div style="display: inline-block; text-align: left; padding-top: 1px; padding-left: 5px">
                  @if (domainConfig.showA2KndNrOverwrite == 'A2KndNrDefault') {
                    {{(currentLieferkunde|async)?.A2KndNrDefault}}
                  }
                  @if (domainConfig.showA2KndNrOverwrite == 'A2KndNrOrganisationseinheit') {
                    {{(currentLieferkunde|async)?.A2KndNr}}
                  }
                  @if (domainConfig.showA2KndNrOverwrite == 'Nein') {
                    {{(currentLieferkunde|async)?.LieferkundeNr}}
                  }
                  - {{(currentLieferkunde|async)?.Vorname}} <br> {{(currentLieferkunde|async)?.Nachname|trim}},
                {{(currentLieferkunde|async)?.Ort}}</div>
              }
            </span>
          }
          @if (!domainConfig.show_customer_numbers) {
            <span>
              <svg-icon verticalAlign="top">lieferadresse</svg-icon>
              @if (!(isMobile|async)) {
                <div style="display: inline-block; text-align: left; padding-top: 1px; padding-left: 5px">
                  {{(currentLieferkunde|async)?.Vorname}} <br> {{(currentLieferkunde|async)?.Nachname|trim}},
                {{(currentLieferkunde|async)?.Ort}}</div>
              }
            </span>
          }
        </a>
      }
      <app-clock position="footer"></app-clock>
    </div>
  }
  @if (!(isMobile|async)) {
    <div style="display: inline-block; float:right">
      <table>
        <tr>
          <td>
            <a routerLink="/docs/impressum" [class.disabled]="disabled|async">Impressum</a>
          </td>
          <td>
            <a routerLink="/docs/datenschutz" [class.disabled]="disabled|async">Datenschutz</a>
          </td>
          <td>
            <a routerLink="/docs/agbs" [class.disabled]="disabled|async">AGBs</a>
          </td>
          <td>
            <a href="#" (click)="openPrivacySettings(); $event.preventDefault()" [class.disabled]="disabled|async" target="_blank">Privatsphäre</a>
          </td>
          <td>
            <small>V {{appVersion}}</small>
          </td>
        </tr>
      </table>
    </div>
  }
  @if ((isMobile|async) && !(mobileShowLinks|async)) {
    <div style="display: inline-block; float:right" (click)="showMobileLinks()">
      <svg-icon>info</svg-icon>
    </div>
  }
  <div style="clear:both;"></div>
</div>

@if ((mobileShowLinks|async)) {
  <div class="mobileLinks">
    <table>
      <tr>
        <td>
          <a routerLink="/docs/impressum" (click)="hideMobileLinks()" [class.disabled]="disabled|async">Impressum</a>
        </td>
      </tr>
      <tr>
        <td>
          <a routerLink="/docs/datenschutz" (click)="hideMobileLinks()"  [class.disabled]="disabled|async">Datenschutz</a>
        </td>
      </tr>
      <tr>
        <td>
          <a routerLink="/docs/agbs" (click)="hideMobileLinks()"  [class.disabled]="disabled|async">AGBs</a>
        </td>
      </tr>
      <tr>
        <td>
          <a href="#" (click)="hideMobileLinks(); openPrivacySettings(); $event.preventDefault()" [class.disabled]="disabled|async" target="_blank">Privatsphäre</a>
        </td>
      </tr>
      <tr>
        <td>
          <small>V {{appVersion}}</small>
        </td>
      </tr>
    </table>
  </div>
}
